import { NonIdealState } from "@blueprintjs/core";

export function ErrorBoundaryFailed() {
  return (
    <NonIdealState
      icon="error"
      title="Error"
      description="An unrecoverable error occurred. Please reload the application."
    />
  );
}
